import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from "../../../../i18next";

import { 
    loadAllTenderTypes,
    loadDineInSettings,
    updateDineInSettings,
    resetDineInSettings,
    resetTenderTypes,
    getPaymentSettings } from '../../../../actions/index';
import ServiceSettings from './ServiceSettings';
import {getCurrencySymbol} from "../../../../utils/CommonUtils";
import { MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../../utils/Constants';

class DineInScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            settingsData: []
        }

        this.updateDineInSettings = this.updateDineInSettings.bind(this);
    }

    componentDidMount() {
        const { role } = this.props.currentlyLoggedInUser;
        this.props.loadAllTenderTypes();
        const restaurantId = this.props.match.params.id;
        this.props.loadDineInSettings(restaurantId);        
        // Response and callback are used to prepopulate payment types
        if (role === MENUU_MASTER_ADMIN) {
            this.props.getPaymentSettings(restaurantId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.dineInSettings !== prevProps.dineInSettings) {
            this.setState({
                settingsData: this.props.dineInSettings
            });
        }
    }

    componentWillUnmount() {
        this.props.resetDineInSettings();
        this.props.resetTenderTypes();
    }

    updateDineInSettings(settings, callback) {
        const restaurantId = this.props.match.params.id;
        let filteredPrepTimes = [];

        if (this.props.serviceSettingsGeneral.timeSlotBased) {
            settings.timeSlots = [...settings.preparationTimes];
            settings.preparationTimes = [];
        } else {
            settings.preparationTimes.map(prepTime => {
                let prepTimeCopy = {...prepTime};
                delete prepTimeCopy.maxOrders;
                delete prepTimeCopy.maxValue;
                delete prepTimeCopy.duration;

                filteredPrepTimes.push(prepTimeCopy);
            });

            settings.preparationTimes = filteredPrepTimes;
        }

        this.props.updateDineInSettings(restaurantId, settings, callback);
    }

    render() {
        const dineInTranslation = i18n.t('common:deliveryCollectionDineInCurbside.operationHoursDinein');
        const currency = getCurrencySymbol(this.props.restaurant.currency);

        return (
            <ServiceSettings
                settings={this.props.dineInSettings}
                prepopulatedSettings={this.state.settingsData}
                updateSettings={this.updateDineInSettings}
                tenderTypes={this.props.tenderTypes}
                translationPhrase={dineInTranslation}
                currency={currency}
                timeSlotBased={this.props.serviceSettingsGeneral.timeSlotBased}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        dineInSettings: state.dineInSettings,
        tenderTypes: state.tenderTypes,
        restaurant: state.restaurant,
        currentlyLoggedInUser: state.user
    }
}

export default connect(mapStateToProps, {
    loadAllTenderTypes,
    loadDineInSettings,
    updateDineInSettings,
    resetDineInSettings,
    resetTenderTypes,
    getPaymentSettings })(DineInScreen);


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/DineInScreen.js